<template>
  <div>
    <div>
      <el-form size="small" label-width="100px" class="margin15-tb">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="模板名称">
            <el-input clearable v-model="templateName"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="模板内容">
            <el-input clearable v-model="templateContent" placeholder="前后加上#可搜索参数"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="text left">
              <el-button type="primary" size="mini" @click="search">搜索</el-button>
              <el-button size="mini" @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <p>
        <el-button icon="el-icon-plus" type="primary" size="small" @click="addTemplate">创建模板</el-button>
        <el-button type="success" size="small" @click="exportExcel">导出Excel</el-button>
        <el-button size="small"  type="danger" @click="upload()">短信模板导入</el-button>
        <el-button
          size="small"
          :icon="allTemplatesExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          :disabled="!hasExpandableTemplates"
          @click="toggleAllTemplates">
          {{ allTemplatesExpanded ? '全部关闭' : '全部展开' }}
        </el-button>
      </p>
    </div>
    <el-dialog title="导入短信模板" width="30%" center :visible.sync="importDialogVisible">
      <el-form label-width="100px" >
        <el-form-item label="文件上传" >
          <el-upload
            class="upload-demo"
            action=""
            ref="upload"
            :before-remove="beforeRemove"
            :limit="1"
            :auto-upload="false"
            :on-change="handleChange"
            :file-list="fileList">
            <el-button size="small" icon="el-icon-upload" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">请用模板进行修改上传</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="default" size="small" icon="el-icon-bottom"><a href="/static/template/msgTemplate.xlsx" download
            style="color: inherit; text-decoration: none;">模板下载</a></el-button>
        <el-button size="small" type="primary" @click="submitFile()">提交数据</el-button>
      </div>
    </el-dialog>
    <div class="padding15-tb">
      <el-table
        ref="templateTable"
        :data="displayList"
        v-loading="loading"
        size="small"
        border
        row-key="id"
        :header-cell-style="{textAlign: 'center'}"
        :row-class-name="tableRowClassName"
        style="width: 100%">
        <el-table-column
          prop="name"
          align="center"
          label="模板名称"
          width="200px">
        </el-table-column>
        <el-table-column
          align="center"
          width="200px"
          label="模板类型">
          <template slot-scope="scope">
            <span v-if="scope.row.parentId !== null && scope.row.branchConditions && scope.row.branchConditions.length > 0">
              {{ formatBranchConditions(scope.row.branchConditions) }}
            </span>
            <span v-else>{{ scope.row.templateType }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="contentShow"
          align="center"
          label="内容">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light" v-if="1 == $getInternationalVersionFlag()">
              <div v-if="languageSelect === '0'" v-html="scope.row.contentShowTrans ? scope.row.contentShowTrans : `---请补充中文翻译---<br>${scope.row.contentShow}`"></div>
              <div v-else v-html="scope.row.contentShow"></div>
              <div v-if="languageSelect === '0'" slot="content" v-html="scope.row.contentShow"></div>
              <div v-else slot="content" v-html="scope.row.contentShowTrans ? scope.row.contentShowTrans : '---请补充中文翻译---'"></div>
            </el-tooltip>
            <div v-html="scope.row.contentShow" v-else></div>
          </template>
        </el-table-column>
        <el-table-column
          prop="sort"
          align="center"
          width="100px"
          label="优先级">
          <template slot-scope="scope">
            <span v-if="scope.row.parentId !== null && scope.row.sort !== null && scope.row.sort !== undefined">{{ scope.row.sort }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="210px">
          <template slot-scope="scope">
            <el-button
              v-if="hasChildren(scope.row)"
              type="text"
              size="medium"
              @click="toggleExpand(scope.row)">
              <i :class="isRowExpanded(scope.row) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
            </el-button>
            <el-button type="text" size="medium" icon="el-icon-plus" v-if="scope.row.parentId === null" @click="addChildTemplate(scope.row)"></el-button>
            <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="editTemplate(scope.row)"></el-button>
            <el-button type="text" size="medium" icon="el-icon-delete" @click="deleteTemplate(scope.row.id)"></el-button>
            &nbsp;
            <el-switch
              v-if="scope.row.parentId !== null"
              v-model="scope.row.status"
              @change="openAndCloseTemplate(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <div class="text center margin15-tb">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.currentPage"
          :page-sizes="[50, 100, 200]"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    initTemplateFiled: {
      type: Function,
      default() {
      }
    },
    addOrEditTemplate: {
      type: Function,
      default() {
      }
    },
    deleteTemplate: {
      type: Function,
      default() {
      }
    },
    openAndCloseTemplate: {
      type: Function,
      default() {
      }
    },
    changeTabe: {
      type: String
    },
    companySelected: {
    },
    groupSelected: {
    },
    companyAmount: {
    }
  },
  watch: {
    changeTabe(type) {
      if (type === '短信模板列表') {
        if (this.companyId !== '') {
          this.getData(1);
        }
      }
    },
    companySelected(companyId) {
      this.companyId = companyId;
    },
    groupSelected(groupId) {
      this.groupId = groupId;
      if (this.changeTabe === '短信模板列表') {
        this.getData(1);
      }
    },
    companyAmount(amount) {
      this.amount = amount;
    }
  },
  data() {
    return {
      importDialogVisible: false,
      loading: true,
      list: [],
      companyId: '',
      groupId: '',
      pageData: {},
      type: 'msg',
      templateName: '',
      templateContent: '',
      templateOperType: {
        addMsg: 'addMsg',
        addVoice: 'addVoice',
        addIvoice: 'addIvoice',
        add: 'add',
        edit: 'edit',
        addChildTemplate: 'addChildTemplate'
      },
      fileList: [],
      currentPage: 1,
      catchLanguageSelect: this.$getLanguageSelect(),
      expandedRowIds: new Set()
    };
  },
  mounted() {
    this.initTemplateFiled(this.templateOperType);
    this.langChangeHandler = (newLang) => {
      this.catchLanguageSelect = newLang;
    };
    this.$bus.$on('languageSelectChanged', this.langChangeHandler);
  },
  beforeDestroy() {
    this.$bus.$off('languageSelectChanged', this.langChangeHandler);
  },
  methods: {
    getData(page) {
      this.loading = true;
      this.$ajax({
        url: '/template/getTemplates',
        method: 'POST',
        data: this.getSearchParam(page)
      }).then((res) => {
        this.addMissingParentTemplates(res.data.list || []).then((list) => {
          this.list = list;
          this.pageData.pageSize = res.data.limit;
          this.pageData.totalCount = res.data.totalRecords;
          this.pageData.currentPage = res.data.currentPage;
          this.currentPage = res.data.currentPage;
          this.loading = false;
        });
      });
    },
    addMissingParentTemplates(list) {
      const rootIds = new Set(
        list.filter(item => item.parentId === null).map(item => String(item.id))
      );
      const missingParentIds = [...new Set(
        list
          .filter(item => item.parentId !== null && !rootIds.has(String(item.parentId)))
          .map(item => String(item.parentId))
      )];

      if (missingParentIds.length === 0) {
        return Promise.resolve(list);
      }

      return this.$ajax({
        url: '/template/getTemplatesParam',
        method: 'POST',
        data: {
          'companyId': this.companyId,
          'groupId': this.groupId,
          'type': this.type
        }
      }).then((res) => {
        const templates = Array.isArray(res.data) ? res.data : ((res.data && res.data.list) || []);
        const templateMap = {};
        templates.forEach((item) => {
          templateMap[String(item.id)] = item;
        });

        const parentTemplates = missingParentIds
          .map(parentId => templateMap[parentId])
          .filter(Boolean)
          .map(item => Object.assign({}, item, {
            parentId: null,
            contentShow: item.contentShow || item.content || item.templateContent || '',
            templateType: item.templateType || '主模板'
          }));

        return parentTemplates.concat(list);
      }).catch(() => list);
    },
    getSearchParam(page) {
      const req = {
        'companyId': this.companyId,
        'groupId': this.groupId,
        'type': this.type,
        'templateName': this.templateName,
        'templateContent': this.templateContent,
        'page': page,
        'limit': this.pageData.pageSize || 50,
        'order': 0,
        'sort': 0
      };
      return req;
    },
    getDataByFirst(companyId, groupId, page) {
      console.warn(page);
      this.companyId = companyId;
      this.groupId = groupId;
      this.getData(this.pageData.currentPage);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getData(1);
    },
    // 页码
    handleCurrentChange(val) {
      this.pageData.currentPage = val;
      this.currentPage = val;
      this.getData(val);
    },
    search() {
      this.getData(1);
    },

    upload() {
      this.importDialogVisible = true;
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    submitFile() {
      this.importDialogVisible = false;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.fileList === [] || this.fileList === null || this.fileList.length === 0) {
        this.$message.error('excel文件不能为空!');
        loading.close();
      }
      const fileList = this.fileList;
      const FileExt = fileList[0].name.replace(/.+\./, '').toLowerCase();
      const xlsxFlag = ['xlsx'].includes(FileExt);
      const isLt5M = fileList[0].size / 1024 / 1024 < 5;
      if (!xlsxFlag) {
        this.$message.error('文件格式错误请重新上传!');
        this.fileList = [];
        loading.close();
        this.importDialogVisible = false;
      }
      if (!isLt5M) {
        this.$message.error('上传的文件大小不能超过 5MB!');
        this.fileList = [];
        loading.close();
        this.importDialogVisible = false;
      }
      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);
      formData.append('groupId', this.groupId);
      formData.append('companyId', this.companyId);
      this.$ajax({
        url: '/strategy/excel/importMsg',
        method: 'POST',
        prompt: true,
        contentType: 'multipart/form-data',
        data: formData
      }).then(() => {
        loading.close();
        this.importDialogVisible = false;
      }).catch(() => {
        loading.close();
        this.importDialogVisible = false;
      });
    },
    exportExcel() {
      this.$download({
        url: '/strategy/excel/exportMessageTemplate',
        method: 'POST',
        data: this.getSearchParam(1),
        name: '短信模板列表.xlsx'
      });
    },
    reset() {
      this.resetSearchParam();
    },
    resetSearchParam() {
      this.templateName = '';
      this.templateContent = '';
    },
    addTemplate() {
      this.addOrEditTemplate(true, this.templateOperType.addMsg, this.companyId, this.groupId, null);
    },
    addChildTemplate(row) {
      const childTemplateRow = Object.assign({}, row, { priorityEditable: true });
      this.addOrEditTemplate(true, this.templateOperType.addChildTemplate, this.companyId, this.groupId, childTemplateRow);
    },
    editTemplate(row) {
      this.addOrEditTemplate(true, this.templateOperType.edit, this.companyId, this.groupId, row);
    },
    toggleExpand(row) {
      if (this.expandedRowIds.has(row.id)) {
        this.expandedRowIds.delete(row.id);
      } else {
        this.expandedRowIds.add(row.id);
      }
      // 触发 displayList 重新计算
      this.expandedRowIds = new Set(this.expandedRowIds);
    },
    toggleAllTemplates() {
      this.expandedRowIds = this.allTemplatesExpanded
        ? new Set()
        : new Set(this.expandableTemplateIds);
    },
    isRowExpanded(row) {
      return this.expandedRowIds.has(row.id);
    },
    hasChildren(row) {
      if (row.isChildRow || row.parentId !== null) return false;
      return this.list.some(item => item.parentId === row.id);
    },
    // 格式化分支模板条件为展示字符串，如：逾期金额 数值 > 111111;逾期天数 数值 >= 1
    formatBranchConditions(branchConditions) {
      if (!branchConditions || !branchConditions.length) return '';
      return branchConditions.map((bc) => {
        let str = `${bc.conditionDesc || ''} ${bc.logicDesc || ''}`;
        if (bc.param1 || bc.param1 === 0) str += ` ${bc.param1}`;
        if (bc.param2 || bc.param2 === 0) str += ` ~ ${bc.param2}`;
        return str;
      }).join(';');
    },
    tableRowClassName({ row }) {
      if (row.parentId === null) {
        return 'main-template-row';
      }
      return 'child-row';
    }
  },
  computed: {
    languageSelect() {
      return this.catchLanguageSelect;
    },
    expandableTemplateIds() {
      return [...new Set(
        this.list
          .filter(item => item.parentId !== null)
          .map(item => item.parentId)
      )];
    },
    hasExpandableTemplates() {
      return this.expandableTemplateIds.length > 0;
    },
    allTemplatesExpanded() {
      return this.hasExpandableTemplates
        && this.expandableTemplateIds.every(id => this.expandedRowIds.has(id));
    },
    // 根据展开状态动态计算显示列表：展开的主模板后紧跟其子模板
    displayList() {
      const result = [];
      const childMap = {};
      const rootIds = new Set();
      const searching = Boolean(this.templateName || this.templateContent);

      this.list.forEach((item) => {
        if (item.parentId !== null) {
          if (!childMap[item.parentId]) {
            childMap[item.parentId] = [];
          }
          childMap[item.parentId].push(item);
        } else {
          rootIds.add(String(item.id));
        }
      });

      this.list.forEach((row) => {
        if (row.parentId !== null) return;
        result.push(row);
        if ((searching || this.expandedRowIds.has(row.id)) && childMap[row.id]) {
          childMap[row.id].forEach((child) => {
            result.push(Object.assign({}, child, { isChildRow: true }));
          });
        }
      });

      Object.keys(childMap).forEach((parentId) => {
        if (!rootIds.has(parentId)) {
          childMap[parentId].forEach((child) => {
            result.push(Object.assign({}, child, { isChildRow: true }));
          });
        }
      });

      return result;
    }
  }
};
</script>
<style scoped>
    .upload-demo {
      display: inline-block;
    }
    /* 子模板行缩进样式 */
    .el-table >>> .child-row td:first-child .cell {
      padding-left: 30px !important;
    }
    /* 主模板行使用灰色底色，与分支模板区分 */
    .el-table >>> .main-template-row > td {
      background-color: rgb(240, 243, 246);
    }
    .el-table >>> .main-template-row:hover > td {
      background-color: #e5e7eb;
    }
</style>



// WEBPACK FOOTER //
// src/page/main/collection/engine/msg_template_list.vue